module.exports = __webpack_public_path__ + "img/5.476cda05.jpg";